import { LOAD_DETALLE_OFICINA, StateDetalleOficina } from "../../types/objetivos/oficinaTypes";

export const loadDetalleOficina = (data: StateDetalleOficina) => ({ type: LOAD_DETALLE_OFICINA, payload: data });
